import React from 'react';
import { ReactSVG } from 'react-svg';
import { translateWithI18Next } from '@kfc-global/kfc-i18n/lib';
import { IMAGE_PATH } from 'common/ImageConstants/ImagePathUtils';
import { TRANSLATE_MAPPING_KEY } from 'common/constants/i18nTranslateKeys';
import { CART_PAGE_CONSTANTS } from 'organisms/CartPage/Constants/CartPageConstants';
import { login } from 'common/utilities/LoginUtils';

const CartPagePromosItem = props => {
  const { contentData, setConfirmationModel, loggedIn } = props;
  const { Error_Yellow, Promos_Coupon_Icon } = IMAGE_PATH;
  const { REMOVE, SIGN_IN, SIGN_UP, PROMO_UNMET_MESSAGE, NOT_SIGNED_IN } = TRANSLATE_MAPPING_KEY;
  const { APPLIED } = CART_PAGE_CONSTANTS;
  const getErrorMessage = allErrorMessage => {
    return allErrorMessage?.map(msg => {
      return <li>{msg}</li>;
    });
  };

  return (
    <>
      {contentData?.map?.(item => {
        const isValidPromos = item?.status === APPLIED && loggedIn ? true : false;
        return (
          <div className={`cart-food-item-container cart-food-item-coupon-container ${!isValidPromos && 'invalid'}`}>
            <div className='cart-offers-container'>
              <div className='cart-offers-link'>
                <ReactSVG src={Promos_Coupon_Icon} alt='Promos_Coupon_Icon' className='cart-offers-icon' />
                <span className='cart-offers-text'>{item?.title}</span>
              </div>
              <span
                aria-label='do you want to remove the above itams'
                className='cart-food-card-item-edit-remove'
                data-testid='cart-promos-remove'
                onClick={() => setConfirmationModel(item)}
              >
                {translateWithI18Next(REMOVE)}
              </span>
            </div>

            {!isValidPromos && (
              <div className='promos-summary-cart-notification'>
                <div className='notify-alert'>
                  <ReactSVG src={Error_Yellow} alt='Error_Yellow' className='location-alert-icon' />
                  <div className='promos-error-massage'>
                    {translateWithI18Next(PROMO_UNMET_MESSAGE)}
                    <ul className='promos-error-list'>
                      {!loggedIn && (
                        <li>
                          {translateWithI18Next(NOT_SIGNED_IN)}{' '}
                          <span
                            className='cart-promos-signinup-text'
                            data-testid='cart-promos-signin'
                            onClick={() => login()}
                          >
                            <span className='cart-promos-signin'>{translateWithI18Next(SIGN_IN)}</span>/
                            <span className='cart-promos-signin'>{translateWithI18Next(SIGN_UP)}</span>
                          </span>
                        </li>
                      )}
                      {item?.allErrorMessage?.length > 0 && getErrorMessage(item?.allErrorMessage)}
                    </ul>
                  </div>
                </div>
              </div>
            )}
          </div>
        );
      })}
    </>
  );
};

export default CartPagePromosItem;
